<template>
  <Teleport to="body" v-if="!isPanelRoute">
    <div
      class="loader-container"
      :class="{ 'fade-out': !globalPageLoading }"
      aria-live="polite"
      :aria-busy="globalPageLoading"
    >
      <div class="loader">
        <img
          src="@/assets/images/jamrock-logo.webp"
          fetchpriority="high"
          alt=""
          class="loader-logo"
          width="150"
          height="150"
        />
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { globalPageLoading } from '@/utils/routeLoadingState';

const route = useRoute();

// En el panel admin (/configuracion) no se muestra el logo con pulse:
// cada página del panel ya tiene su propio contenedor con skeletons.
const isPanelRoute = computed(() => route.path.startsWith('/configuracion'));
</script>

<script>
export default {
  name: 'LoaderAnimation',
};
</script>

<style scoped>
/* Sin transition en el estado visible: al quitar fade-out el overlay debe ser opaco al instante
   (si no, 0.35s de opacidad intermedia deja ver la navbar blanca debajo). */
.loader-container {
  position: fixed;
  inset: 0;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  box-sizing: border-box;
  margin: 0;
  background: var(--bg-color, #000000);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.loader-container.fade-out {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.28s ease,
    visibility 0.28s ease;
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loader-logo {
  width: 150px;
  height: auto;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>
